import { useQuery } from '@tanstack/react-query'
import { subscriptionApi } from '../api/subscription.api'

export function useInvoices() {
  return useQuery({
    queryKey: ['subscription', 'invoices'],
    queryFn: () => subscriptionApi.fetchInvoices().then((r) => r.data.data),
    staleTime: 60_000,
  })
}
